export const DIAGNOSTIC_FILTERS = ["in-use", "archived", "all"] as const;
export type DiagnosticFilter = (typeof DIAGNOSTIC_FILTERS)[number];
// `?status=` da lista. Sem valor (ou com valor inválido), mostra os em uso: ativo e rascunhos.
export const diagnosticsSearch = (
  search: Record<string, unknown>,
): { status?: Exclude<DiagnosticFilter, "in-use"> } =>
  search.status === "archived" || search.status === "all" ? { status: search.status } : {};
